import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, exportSelectAllQueues, exportDeleteQueues } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons';

function QueuesList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [queuesLocal, setQueuesLocal] = useState(() => []);
  const [queuesSelected, setQueuesSelected] = useState([]);
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const fetchQueues = async () => {
    const queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) setLoading(true);
    const elements = queuesList.map((element) => element.queuesselect);
    setQueuesLocal(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const queuesFetched = await fetchQueues();
    return queuesFetched;
  }, []);

  const handleChangeSelectedQueues = (element) => {
    setQueuesSelected((prevState) => {
      const onlineState = element;
      onlineState.length > 0 ? setDisable(false) : setDisable(true);
      return onlineState;
    });
  };

  const handleClickDelete = async () => {
    const sendDeleteQueues = await exportDeleteQueues({ queue: queuesSelected });
    if(sendDeleteQueues.length === undefined) {
      toggleIsHidden('#alert-confirm-queues-delete');
      return toggleIsChangeFormElements('alert-queues-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-queues-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(queuesSelected);
    return history.push('/config/fila/lista/nome');
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">FILAS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-queues-not-delete" name="alert-queues-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-queues-not-delete') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar os ramais selecionados.
            </div>
          </article>
          <article id="alert-confirm-queues-delete" name="alert-confirm-queues-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-queues-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar os ramais selecionados?
            </div>
            <br />
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-danger is-half mx-3 px-5 is-offset-one-quarter" type="submit" onClick={ () => handleClickDelete() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Confirmar
                    </span>
              </button>
              <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-queues-delete')
                toggleIsHidden('#buttons')
              }}>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
              </button>
            </div>
          </div>
          </article>
          <div className="columns">
            <article className="panel is-info is-4 is-offset-4 column has-text-centered">
              <p className="panel-heading">
                Filas
              </p>
              {
                queuesLocal.map((phone) => {
                  return (
                    <a className="panel-block" key={ phone }>
                      <input name="name-queue" type="radio" value={ phone } onChange={ (e) => handleChangeSelectedQueues(e.target.value)} />
                      <span className="ml-5">{ phone }</span>
                    </a>
                  )
                })
              }
            </article>
          </div>
          <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ disable }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faPen } fixedWidth />
                      </span>
                      <span>
                        Visualizar
                      </span>
                </button>
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-queues-delete')
                    toggleIsHidden('#buttons')
                    }}
                  disabled={ disable }
                >
                  <span className="icon">
                    <FontAwesomeIcon icon={ faTrash } fixedWidth />
                  </span>
                  <span>
                    Deletar
                  </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default QueuesList;
